import { BRAND_NETWORK, networkSite } from "@/data/brand-network";

/** Compact branded list for the footer. */
export function BrandNetworkFooterList() {
  return (
    <ul className="mt-3 space-y-2 text-sm">
      {BRAND_NETWORK.map((s) => (
        <li key={s.url}>
          <a href={s.url} target="_blank" rel="noopener" className="text-primary-foreground/80 hover:text-brand-gold">
            {s.name}
          </a>
        </li>
      ))}
    </ul>
  );
}

/** Full card grid for the About page. */
export function BrandNetworkGrid() {
  return (
    <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {BRAND_NETWORK.map((s) => (
        <a
          key={s.url}
          href={s.url}
          target="_blank"
          rel="noopener"
          className="rounded-lg border border-border bg-card p-5 transition hover:border-brand-gold"
        >
          <div className="font-semibold text-foreground">{s.name}</div>
          <p className="mt-1 text-sm text-muted-foreground">{s.focus}</p>
        </a>
      ))}
    </div>
  );
}

/** One contextual editorial callout pointing to relevant sister sites. */
export function NetworkCallout({
  title,
  body,
  sites,
}: {
  title: string;
  body: string;
  sites: string[];
}) {
  return (
    <section className="container mx-auto my-12 max-w-4xl px-4">
      <div className="rounded-xl border border-border bg-muted/40 p-6">
        <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">From the Simply Approved family</div>
        <h2 className="mt-1 font-display text-xl text-foreground">{title}</h2>
        <p className="mt-2 text-sm text-muted-foreground">{body}</p>
        <ul className="mt-3 flex flex-wrap gap-x-6 gap-y-2 text-sm">
          {sites.map((n) => {
            const s = networkSite(n);
            return (
              <li key={s.url}>
                <a href={s.url} target="_blank" rel="noopener" className="font-semibold text-brand hover:underline">
                  {s.name} →
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
